import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["source", "dependent", "hint"]
  static values = {
    optionsMap: Object,
    showAllWhenEmpty: { type: Boolean, default: false },
    url: String,
    param: String
  }

  connect() {
    if (this.hasUrlValue) {
      this.syncedKey = this.selectedValues().join(",")
    } else {
      window.requestAnimationFrame(() => this.sync())
    }
  }

  sync() {
    const values = this.selectedValues()
    const key = values.join(",")
    if (key === this.syncedKey) return

    this.syncedKey = key
    if (this.hasHintTarget) this.hintTarget.classList.toggle("tw-hidden", values.length > 0)

    if (this.hasUrlValue) {
      this.loadOptions(values, key)
    } else {
      this.replaceOptions(this.optionsFor(values))
    }
  }

  async loadOptions(values, key) {
    let options = []

    if (values.length > 0) {
      const url = new URL(this.urlValue, window.location.origin)
      values.forEach((value) => url.searchParams.append(this.paramValue, value))

      try {
        const response = await fetch(url, { headers: { Accept: "application/json" }, credentials: "same-origin" })
        if (response.ok) options = (await response.json()).results
      } catch (error) {
        console.warn("Dependent options request failed", error)
      }
    }

    if (key === this.syncedKey) this.replaceOptions(options)
  }

  replaceOptions(options) {
    this.application
      .getControllerForElementAndIdentifier(this.dependentTarget, "multi-select-dropdown")
      .replaceOptions(options)
  }

  selectedValues() {
    return this.sourceTargets.flatMap((source) =>
      Array.from(source.querySelectorAll("input[type='checkbox']:checked:not(:disabled)")).map((input) => input.value)
    )
  }

  optionsFor(values) {
    if (values.length === 0 && this.showAllWhenEmptyValue) return this.allOptions()

    return this.sortedOptions(values.flatMap((value) => this.optionsMapValue[value] || []))
  }

  allOptions() {
    return this.sortedOptions(Object.values(this.optionsMapValue).flat())
  }

  sortedOptions(options) {
    const optionsByValue = new Map(options.map((option) => [String(option.value), option]))

    return Array.from(optionsByValue.values()).sort((left, right) => left.label.localeCompare(right.label))
  }
}
